import { openApi } from '@/api/request'

export default {
    upvote (requestData) {
        const url = '/Rccl.OpenApi/TUITravel/CheckUpvoteHPApi'
        return openApi.post(url, requestData)
    },
    getUpvote (requestData) {
      return openApi.post('/Rccl.OpenApi/TUITravel/GetReviewUpvote', requestData)
    },
    getReviewPics (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/GetReviewPics', requestData)
    },
    upVotePic (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/UpvotePic', requestData)
    },
    getReviewDetail (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/Detail', requestData)
    },
    getReviewPicsFilter (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/GetReviewPicsFilter', requestData)
    },
    getMinePic ({Offset, Limit, SailDate, ShipCode}) {
        return openApi.post('/Rccl.OpenApi/TUITravel/GetMineApi', {
            Offset,
            Limit,
            SailDate,
            ShipCode
        })
    },
    uploadPic ({userName, images}) {
        return openApi.post('/Rccl.OpenApi/TUITravel/UploadPicMulti', {
            userName,
            images
        })
    },
    createPic (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/Create', requestData)
    },
    updateNickName (userName, nickName) {
        return openApi.post('/Rccl.OpenApi/TUITravel/UpdateNickName', {
            userName,
            nickName
        })
    },
    getNickName (userName) {
        return openApi.get('/Rccl.OpenApi/TUITravel/NickName', {
            params: {
                userName,
                v: (new Date()).getTime()
            }
        })
    },
    getTravelNotes (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/TravelNotesAction', requestData)
    },
    getTravelNoteDetail (requestData) {
        return openApi.post('/Rccl.OpenApi/TUITravel/DetailAction', requestData)
    },
    upVoteHP ({userName, articalId}) {
        return openApi.post('/Rccl.OpenApi/TUITravel/CheckUpvoteHPApi', {
            userName,
            articalId
        })
    },
    getGuide () {
        return openApi.get('/Rccl.OpenApi/TUITravel/Guide')
    }
}

